import type { AttemptOutcome, ReviewState } from '../../types';

/**
 * Planification de révision espacée simplifiée : J+2 puis J+7, doublement
 * ensuite en cas de succès autonome répétés ; réinitialisation courte (J+1)
 * après un échec ou une solution révélée, pour retravailler vite le point faible.
 */
const FIRST_INTERVAL_DAYS = 2;
const SECOND_INTERVAL_DAYS = 7;
const FAILURE_INTERVAL_DAYS = 1;
const HINTED_INTERVAL_DAYS = 3;

export function computeNextReview(current: ReviewState, outcome: AttemptOutcome, now: Date = new Date()): ReviewState {
  let intervalDays: number;
  let streak: number;

  switch (outcome) {
    case 'autonomous_success': {
      streak = current.streak + 1;
      if (streak === 1) intervalDays = FIRST_INTERVAL_DAYS;
      else if (streak === 2) intervalDays = SECOND_INTERVAL_DAYS;
      else intervalDays = Math.round(current.intervalDays * 2);
      break;
    }
    case 'hinted_success': {
      // Réussite avec aide : on ne casse pas toute la progression, mais on
      // ne l'accélère pas non plus — révision un peu plus rapprochée.
      streak = Math.max(0, current.streak);
      intervalDays = HINTED_INTERVAL_DAYS;
      break;
    }
    case 'revealed':
    case 'failed_attempt': {
      streak = 0;
      intervalDays = FAILURE_INTERVAL_DAYS;
      break;
    }
  }

  const dueAt = new Date(now.getTime() + intervalDays * 24 * 60 * 60 * 1000).toISOString();
  return { dueAt, intervalDays, lastOutcome: outcome, streak };
}

export function isDue(review: ReviewState, now: Date = new Date()): boolean {
  return new Date(review.dueAt).getTime() <= now.getTime();
}
